import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractPreview, extractSmartLinkEmbed, extractSmartLinkTitle, extractSmartLinkUrl, extractType } from '@atlaskit/link-extractors';
import { fg } from '@atlaskit/platform-feature-flags';
import { getEmptyJsonLd } from '../../utils/jsonld';
import { extractSmartLinkContext } from '../common/context';
import { extractIsSupportTheming } from '../common/meta/extractIsSupportTheming';
import { extractIsTrusted } from '../common/meta/extractIsTrusted';
var extractEmbedPreview = function extractEmbedPreview(jsonLd, platform, iframeUrlType) {
  var preview = extractPreview(jsonLd, platform, iframeUrlType);
  if (preview && preview.src) {
    return _objectSpread(_objectSpread({}, preview), {}, {
      src: preview.src
    });
  }
};
export var extractEmbedProps = function extractEmbedProps(response, platform, iframeUrlType) {
  var meta = response === null || response === void 0 ? void 0 : response.meta;
  var jsonLd = (response === null || response === void 0 ? void 0 : response.data) || getEmptyJsonLd();
  return _objectSpread({
    link: extractSmartLinkUrl(response) || '',
    title: extractSmartLinkTitle(response),
    context: extractSmartLinkContext(response),
    preview: fg('smart_links_noun_support') ? extractSmartLinkEmbed(response, iframeUrlType) : extractEmbedPreview(jsonLd, platform, iframeUrlType),
    isTrusted: extractIsTrusted(meta),
    isSupportTheming: extractIsSupportTheming(meta)
  }, fg('platform-linking-visual-refresh-v2') && {
    type: extractType(jsonLd)
  });
};